const shape = {
  borderRadius: 6,
  borderRadiusSm: 12,
  borderRadiusMd: 16
};

export default shape;
